import React, { useEffect, useState } from 'react'
import request from 'services/http'
import { toast } from 'react-toastify'
import { Button, Icon, Divider } from 'semantic-ui-react'
import Table from 'components/Table'
import PageLoader from 'components/PageLoader'
import { numFormat } from '@rededompedro/utils'
import RateioForm from './RateioForm'

const MyContext = React.createContext()
export { MyContext }

export default function Diferencas({ history, empresas, dados, setDados, justificativas }) {

	const [isFetching] = useState(dados ? false : true)
	const [selectedRow, setSelectedRow] = useState(null)
	const params = Object.fromEntries(
		new URLSearchParams(history.location.search.replace('?=', '')).entries(),
	)
	const emp = empresas.find((it) => it.codDpnet === params.empresa)
	const [valorJustificativa, setValorJustificativa] = useState()


	useEffect(() => {
		request({
			url: '/controladoria/apuracao-caixa',
			method: 'GET',
			params,
		})
			.toPromise()
			.then(({ response }) => {
				setDados({
					turnos: response.turnos
				})
			})
			.catch((err) => {
				toast.error('Falha ao carregar dados!')
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedRow])




	const goBack = () => {
		if (!selectedRow) {
			history.goBack()
		} else {
			setSelectedRow(null)
		}
	}

	async function validarValorJustificativas(it) {

		let payload = {
			seq: it.sequencia
		}

		await request({
			url: '/controladoria/apuracao-caixa/validacao',
			method: 'POST',
			body: payload,
		})
			.toPromise()
			.then(({ response }) => {
				if (response) {
					setValorJustificativa(response)
					setSelectedRow(it)
				} else {
					toast.error(`Houve um erro interno!`, {
						toastId: 'differenceError',
					})
				}
			})
			.catch((err) => {
				toast.error(`Houve um erro interno!`, {
					toastId: 'differenceError',
				})
			})


	}

	function formatarNomeAtendente(nome) {
		let nomeMinusculo = nome.toLowerCase()
		let nomeFormatado = nomeMinusculo.charAt(0).toUpperCase() + nomeMinusculo.slice(1)
		return nomeFormatado
	}
	const config = {
		columns: [
			{ field: 'sequencia', text: 'Sequência', sort: true },
			{ field: 'data', text: 'Data do Caixa', sort: true },
			{ field: 'turno', text: 'Turno', sort: true },
			{ field: 'diferenca', text: 'Diferença', sort: true },
			{ field: 'status', text: 'Status', sort: false },
			{ field: 'nome', text: 'Atendente', sort: false },
			{ field: 'descricao', text: 'Descrição', sort: false },
			{ field: 'excecao', text: 'Pendência', sort: false },
			{ field: 'just', text: 'Justificativa', sort: false },
		],
		data:
			dados.turnos && dados.turnos.length
				? dados.turnos.map((it) => ({
					just: (
						<Button
							onClick={() => validarValorJustificativas(it)}
							icon
							size="mini"
							color="instagram"
							labelPosition="right"
							content={
								<>
									<Icon name="arrow right" /> Registrar
								</>
							}
						/>
					),
					nome: formatarNomeAtendente(it.nome),
					sequencia: it.sequencia,
					data: it.data,
					turno: it.turno,
					diferenca: 'R$ ' + numFormat(it.diferenca),
					descricao: it.descricao ? 'Em andamento' : 'Aguardando Registro',
					excecao: it.excecao === '01' ? (<Icon name='attention' color='orange'>  Pendente</Icon>  ): <Icon color='green' name='checkmark'>  Justificado</Icon>,
					status: it.status === 'V' ? 'Validado' : 'Lançado',
				}))
				: [],
		filter: true,
		exportData: true,
	}
	const rateioProps = { emp, justificativas, selectedRow, valorJustificativa }
	return (
		<>
			<MyContext.Provider value={{ setSelectedRow }}>
				<PageLoader active={isFetching}>
					<div className="row mt-2">
						<div className="col-12 col-md d-flex align-items-end">
							<p className="mb-0">
								<strong>Empresa: </strong> {emp ? emp.nomeEmpresa : ''} -{' '}
								{params.dataIni + ' Até ' + params.dataFim}
							</p>
						</div>
						<div className="col-12 col-md-2 d-print-none">
							<Button
								icon
								size="tiny"
								className="btn-red"
								floated="right"
								onClick={goBack}
							>
								<Icon name="arrow left" /> Voltar
							</Button>
						</div>
					</div>

					<Divider className="mt-2 custom-divider darken" fitted />

					{dados && !selectedRow && (
						<Table
							id="table-apuracao-caixas"
							singleLine
							fixed
							celled
							sortable
							compact
							selectable
							{...config}
						/>
					)}

					{selectedRow && <RateioForm {...rateioProps} />}
				</PageLoader>
			</MyContext.Provider>
		</>
	)
}
